module.exports = __webpack_public_path__ + "static/img/cta_background.46b7830.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cta_background.svg
// module id = 1441
// module chunks = 4